import { Button, notification } from 'antd';
import { StrykerAlertColor } from 'osep-react-antd';
import type { OAuthProvider } from 'osep-auth-service-client-v1';
import { useConnectionsQuery } from '../../hooks/query/useConnectionsQuery';
import { useStartOAuthFlowMutation } from '../../hooks/mutations/useStartOAuthFlowMutation';
import { useDeleteConnectionMutation } from '../../hooks/mutations/useDeleteConnectionMutation';
import { PROVIDERS } from './providers';

type Props = { provider: OAuthProvider };

const ConnectionButton = ({ provider }: Props) => {
  const [api, notificationHolder] = notification.useNotification();
  const { label } = PROVIDERS[provider];
  const { data: connections, isLoading } = useConnectionsQuery();
  const { mutate: startOAuthFlow, isPending: isConnecting } =
    useStartOAuthFlowMutation();
  const { mutate: deleteConnection, isPending: isDisconnecting } =
    useDeleteConnectionMutation();

  const connection = connections?.[provider];

  if (isLoading) {
    return (
      <Button type="primary" block disabled>
        Connect to {label}
      </Button>
    );
  }

  if (!connection) {
    return (
      <>
        {notificationHolder}
        <Button
          type="primary"
          block
          style={{
            backgroundColor: StrykerAlertColor.SUCCESS,
            borderColor: StrykerAlertColor.SUCCESS,
            color: 'white',
          }}
          loading={isConnecting}
          onClick={() =>
            startOAuthFlow(provider, {
              onError: () =>
                api.error({
                  message: 'Connection failed',
                  description: `Could not start the ${label} connection. Please try again.`,
                }),
            })
          }
        >
          Connect to {label}
        </Button>
      </>
    );
  }

  return (
    <>
      {notificationHolder}
      <Button
        type="primary"
        block
        style={{
          backgroundColor: StrykerAlertColor.ERROR,
          borderColor: StrykerAlertColor.ERROR,
          color: 'white',
        }}
        loading={isDisconnecting}
        onClick={() =>
          deleteConnection(connection.id, {
            onError: () =>
              api.error({
                message: 'Error',
                description: `Failed to disconnect ${label}. Please try again.`,
              }),
          })
        }
      >
        Disconnect from {label}
      </Button>
    </>
  );
};

export default ConnectionButton;
